// extracted by mini-css-extract-plugin
export default {"content":"PopularPersonPage_content__UBpuq","content_title":"PopularPersonPage_content_title__Ep2gT","content_cards":"PopularPersonPage_content_cards__qf3jw"};